export default "__VITE_ASSET__DN6Q6ldm__";